const normalizeSegment = (value = "") =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

export const normalizeBusinessSlug = (businessName = "") => {
  const slug = normalizeSegment(businessName);
  return slug === "store" ? "" : slug;
};

export const getStorefrontPath = ({
  businessName,
  bussinessUuid,
  suffix = "",
}) => {
  if (!bussinessUuid) {
    return "/store";
  }

  const businessSlug = normalizeBusinessSlug(businessName);
  const basePath = businessSlug
    ? `/${businessSlug}/store/${bussinessUuid}`
    : `/store/${bussinessUuid}`;
  const normalizedSuffix = suffix.toString().replace(/^\/+/, "");

  return normalizedSuffix ? `${basePath}/${normalizedSuffix}` : basePath;
};

export const getLandingPagePath = ({ businessName, bussinessUuid }) => {
  if (!bussinessUuid) {
    return "/";
  }

  const businessSlug = normalizeBusinessSlug(businessName);
  return businessSlug
    ? `/${businessSlug}/${bussinessUuid}/landingPage`
    : `/${bussinessUuid}/landingPage`;
};

export const getAbsoluteStorefrontUrl = ({
  businessName,
  bussinessUuid,
  suffix = "",
}) =>
  `${window.location.origin}${getStorefrontPath({
    businessName,
    bussinessUuid,
    suffix,
  })}`;
